import _ from "lodash";
import {
  CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER,
  CUSTOM_STORE_LISTING_ID_PLACEHOLDER,
  FIELD_ADDRESS_REQUIRED_AD_PREVIEW,
  FIELD_APP_ID_REQUIRED_AD_PREVIEW,
  FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW,
  FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW,
  FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW,
  FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW,
  FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW,
  FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW,
  FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW,
  FIELD_PAGE_ID_REQUIRED_AD_PREVIEW,
  FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW,
  FIELD_POST_ID_REQUIRED_AD_PREVIEW,
  FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW,
  FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION,
  PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL,
} from "../i18n/keysTranslations";
import {
  ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE,
  ADS_CAMPAIGN_GET_DIRECTIONS_CALL_TO_ACTION_OPTION,
  ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_MESSAGE_TEMPLATE,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_IG_REQUIRED,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  META,
} from "../utils/constants";
import { getIsSpecialAdWithoutCallToAction } from "./adsCampaigns";

export const PRESETS = [
  {
    key: "viewedOrAddedNotPurchased",
    labelKey:
      PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL,
    descriptionKey:
      PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION,
    days: 14,
    structure: {
      inclusions: [
        {
          retentionSeconds: "1209600", // 14 days
          rule: '{"event":{"eq":"ViewContent"}}',
        },
        {
          retentionSeconds: "1209600",
          rule: '{"event":{"eq":"AddToCart"}}',
        },
      ],
      exclusions: [
        {
          retentionSeconds: "1209600",
          rule: '{"event":{"eq":"Purchase"}}',
        },
      ],
      productSetID: null,
    },
  },
  {
    key: "addedNotPurchased",
    labelKey: PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL,
    descriptionKey:
      PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION,
    days: 28,
    structure: {
      inclusions: [
        {
          retentionSeconds: "2419200", // 28 days
          rule: '{"event":{"eq":"AddToCart"}}',
        },
      ],
      exclusions: [
        {
          retentionSeconds: "2419200",
          rule: '{"event":{"eq":"Purchase"}}',
        },
      ],
      productSetID: null,
    },
  },
  {
    key: "upsell",
    labelKey: PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL,
    descriptionKey: PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION,
    productSetLabelKey:
      PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL,
    days: 14,
    structure: {
      inclusions: [
        {
          retentionSeconds: "1209600",
          rule: '{"event":{"eq":"ViewContent"}}',
        },
        {
          retentionSeconds: "1209600",
          rule: '{"event":{"eq":"AddToCart"}}',
        },
      ],
      exclusions: [
        {
          retentionSeconds: "1209600",
          rule: '{"event":{"eq":"Purchase"}}',
        },
      ],
      productSetID: null,
    },
  },
  {
    key: "crossSell",
    labelKey: PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL,
    descriptionKey: PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION,
    productSetLabelKey:
      PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL,
    days: 14,
    structure: {
      inclusions: [
        {
          retentionSeconds: "1209600",
          rule: '{"event":{"eq":"Purchase"}}',
        },
      ],
      exclusions: [],
      productSetID: null,
    },
  },
];

export const detectPreset = ({ productSetAudience = {}, productSetID }) => {
  if (_.isEmpty(productSetAudience)) return PRESETS[0].key;

  const {
    inclusions = [],
    exclusions = [],
    productSetID: productSetIDFromAudience,
  } = productSetAudience;

  // Helper function to check if arrays match
  const arraysMatch = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item1, index) => {
      const item2 = arr2[index];
      return item1.rule === item2.rule;
    });
  };

  // Check each preset
  for (const preset of PRESETS) {
    const presetInclusions = preset.structure.inclusions;
    const presetExclusions = preset.structure.exclusions || [];

    if (
      arraysMatch(inclusions, presetInclusions) &&
      arraysMatch(exclusions, presetExclusions)
    ) {
      if (preset.key === "viewedOrAddedNotPurchased") {
        if (productSetIDFromAudience === productSetID) {
          return preset.key;
        } else {
          return "upsell";
        }
      }
      return preset.key;
    }
  }

  return "custom";
};

export const CARD_TYPES = {
  INTRO: "intro",
  CATALOG: "catalog",
  PROFILE: "profile",
};

export const MAP_CUSTOM_PAGE_ID_PLACEHOLDER = {
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION]:
    CUSTOM_STORE_LISTING_ID_PLACEHOLDER,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION]:
    CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER,
};

export const validationMetaAdPreview = ({
  objective,
  destinationTypeAdGroup,
  destinationTypeAd,
  callToAction,
  appID,
  pageID,
  instagramID,
  isCatalogAd,
  productSetID,
  isCarousel,
  isInstantExperience,
  isDynamicCreative,
  mediaData,
  mediaUrls = [],
  instantExperience,
  currentMediaData,
  address,
  destinationUrls = [],
  isPostAd = false,
  isPartnershipAd = false,
  sponsorPageID = "",
}) => {
  mediaUrls = _.cloneDeep(mediaUrls).filter((mediaUrl) => mediaUrl?.trim());
  if (
    !getIsSpecialAdWithoutCallToAction({
      platform: META,
      objective,
      destinationTypeAdGroup,
      destinationTypeAd,
      mediaData,
      callToAction,
    }) &&
    !callToAction
  ) {
    return { ok: false, message: FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW };
  }

  if (!pageID) {
    return { ok: false, message: FIELD_PAGE_ID_REQUIRED_AD_PREVIEW };
  }

  if (isPartnershipAd) {
    if (!String(sponsorPageID || "").trim()) {
      return { ok: false, message: FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW };
    }
  }

  if (
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_IG_REQUIRED.includes(
      destinationTypeAdGroup
    ) &&
    !instagramID
  ) {
    return { ok: false, message: FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW };
  }

  if (
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationTypeAdGroup
    ) &&
    !appID
  ) {
    return { ok: false, message: FIELD_APP_ID_REQUIRED_AD_PREVIEW };
  }

  const isOnPostDestination = getIsOnPostDestinationMeta({
    destinationType: destinationTypeAdGroup,
    isPostAd,
  });
  if (!isOnPostDestination && !isCatalogAd && _.isEmpty(mediaUrls))
    return {
      ok: false,
      message: FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW,
    };

  if (isInstantExperience && !instantExperience?.link) {
    return {
      ok: false,
      message: FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW,
    };
  }
  if (isCatalogAd && !productSetID) {
    return {
      ok: false,
      message: FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW,
    };
  }
  if (
    isCatalogAd &&
    isCarousel &&
    mediaData?.[0]?.type === CARD_TYPES.INTRO &&
    !mediaUrls?.[0]
  ) {
    return {
      ok: false,
      message: FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW,
    };
  }
  if (
    isCarousel &&
    mediaUrls?.length < 2 &&
    !isCatalogAd &&
    !isDynamicCreative
  ) {
    return {
      ok: false,
      message: FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW,
    };
  }
  if (isOnPostDestination && !currentMediaData?.postID)
    return {
      ok: false,
      message: FIELD_POST_ID_REQUIRED_AD_PREVIEW,
    };

  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION &&
    callToAction === ADS_CAMPAIGN_GET_DIRECTIONS_CALL_TO_ACTION_OPTION &&
    (!address?.name || !address?.lat || !address?.lng)
  ) {
    return {
      ok: false,
      message: FIELD_ADDRESS_REQUIRED_AD_PREVIEW,
    };
  }

  const isPostCarousel = getIsPostCarousel({
    objective,
    destinationType: destinationTypeAdGroup,
    mediaData: mediaData,
    isPostAd,
  });

  if (
    isPostCarousel &&
    callToAction !== ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE &&
    !destinationUrls?.[0]?.value?.trim()
  )
    return {
      ok: false,
      message: FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW,
    };

  if (
    destinationTypeAdGroup ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION &&
    destinationTypeAd === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
  ) {
    if (isCarousel) {
      const expectedLength = mediaUrls.length;
      const destinationUrlsFiltered =
        destinationUrls?.slice(0, expectedLength) || [];

      let hasError = false;
      destinationUrlsFiltered.forEach((destinationUrl) => {
        if (!destinationUrl?.value || !destinationUrl?.value?.trim()) {
          hasError = true;
        }
      });

      if (hasError) {
        return {
          ok: false,
          message: FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW,
        };
      }
    } else if (
      !destinationUrls?.length ||
      !destinationUrls?.[0]?.value?.trim()
    ) {
      return {
        ok: false,
        message: FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW,
      };
    }
  }
  return { ok: true };
};

export const getIsCatalogAd = ({
  platformData,
  objective,
  catalogIDAdGroup,
  creativeSource,
}) => {
  if (platformData?.isCatalogCampaign) return true;

  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION &&
    catalogIDAdGroup
  )
    return true;

  if (
    creativeSource === ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
  )
    return true;

  return false;
};

export const getApplicationUrlMeta = ({ destinationType, appData = {} }) => {
  switch (destinationType) {
    case ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION:
      return appData?.objectStoreUrls?.google_play;
    case ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION:
      return appData?.objectStoreUrls?.itunes;

    default:
      return null;
  }
};

export const getIsOnPostDestinationMeta = ({
  destinationType,
  isPostAd = false,
}) => {
  return (
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION ||
    isPostAd
  );
};

export const getIsPostCarousel = ({
  destinationType,
  mediaData,
  isPostAd = false,
}) => {
  const isPostAdMode = getIsOnPostDestinationMeta({
    destinationType,
    isPostAd,
  });
  return mediaData?.[0]?.isCarousel && isPostAdMode;
};

export const getIsMessageTemplateRequired = ({
  destinationType,
  objective,
  mediaData,
  callToAction,
  isPostAd = false,
}) => {
  const isPostCarousel = getIsPostCarousel({
    objective,
    destinationType,
    mediaData,
    isPostAd,
  });

  if (
    isPostCarousel &&
    callToAction === ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE
  ) {
    return true;
  }

  if (
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_MESSAGE_TEMPLATE.includes(
      destinationType
    )
  )
    return true;

  return false;
};

export const getShowAdScheduleMeta = ({ objective, isPostAd = false }) => {
  if (isPostAd) return false;

  if (
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION ||
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION
  )
    return true;
  return false;
};

export const getIsDynamicCreativeVisible = ({ objective, destinationType }) => {
  if (!objective || !destinationType) return false;

  if (objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION) {
    return (
      destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION ||
      destinationType ===
        ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION
    );
  }

  return destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION;
};
